export { default as globalStyles } from "./globalstyles.global.scss";
export const customScrollBar = "customScrollBar";
export const customScrollBarOnHover = "customScrollBarOnHover";
